export default __webpack_public_path__ + "assets/sounds/94747da96b3dd4170e60b2f270855c56.mp3";